/**
 * ContactSection Component
 * Main contact section with image and contact information
 */

import React from 'react';
import Image from 'next/image';
import ContactInfo from './ContactInfo';
import { ContactGlobal } from '@/types/contactType';

interface ContactSectionProps {
  contactInfo: ContactGlobal | null;
  loading: boolean;
  error: string | null;
}

export default function ContactSection({ contactInfo, loading, error }: ContactSectionProps) {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative h-[200px] lg:h-[340px] rounded-2xl overflow-hidden">
            <Image
              src="/contact_img.jpg"
              alt="Kiến Tạo Xanh Group - Net Zero Environmental Consulting"
              fill
              className="object-cover"
              priority
            />
          </div>

          {/* Right Side - Contact Content */}
          <div className="space-y-8 ml-10">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                Kiến Tạo Xanh Group
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Liên hệ với chúng tôi
              </p>
            </div>

            {/* Contact Information */}
            <ContactInfo 
              contactInfo={contactInfo}
              loading={loading}
              error={error}
            />

            <div className="pt-4">
              <button className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200">
                Đăng ký tư vấn
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}